import {defaultPagination} from "@/services/pagination";
import {exportSnapshot, listSeats, refresh} from "@/services/api/app/salesforce/seats"

const defaultState = () => ({
  seats: [],
  pagination: {
    ...defaultPagination(),
    sortBy: 'firstName',
  },
  search: null,
})

export default {
  namespaced: true,
  actions: {
    listSeats({commit, state}, data) {
      return listSeats({
        ...data,
        pagination: state.pagination,
        search: state.search,
      })
        .then(({result, pagination}) => {
          commit('setSeats', result);
          commit('setPagination', pagination);
        })
        .catch(error => {
          console.error("Failed to list seats:", error);
          throw error;
        });
    },
    refresh({commit}) {
      return refresh()
    },
    exportSnapshot({commit}, {search, pagination}) {
      return exportSnapshot(search, pagination)
    },
  },
  mutations: {
    setSeats(state, seats) {
      state.seats = seats;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    resetPagination(state, newPagination = defaultState().pagination) {
      state.pagination = newPagination;
    },
    setSearch(state, search) {
      state.search = search;
    },
    resetState(state) {
      Object.assign(state, defaultState())
    },
  },

  state: defaultState
}
